module.exports = __webpack_public_path__ + "src/assets/img/04_4art_3part.cb631a73.jpg";